import layout from '@/layout'

const meta = {
  auth: true
}

export default {
  path: '/digitalExhibitionHall',
  component: layout,
  children: ((pre) => [
    {
      path: 'sampleInfo',
      name: `${pre}sampleInfo`,
      meta: {
        ...meta,
        cache: true,
        title: '样品资料库',
        head: true,
        funcID: 'T000201',
        PID: 'T00'
      },
      component: () => import('@/views/digital/digitalExhibitionHall/sampleInfo')
    },
    {
      path: 'sampleInfo/detail/:sampleCode',
      name: `${pre}sampleInfo-detail`,
      meta: {
        ...meta,
        cache: true,
        dynamicTitle: true,
        title: '样品资料库详情',
        funcID: 'T000201',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/digitalExhibitionHall/sampleInfo/components/detail')
    },
    {
      path: 'designElementsInfo',
      name: `${pre}design-elementsInfo`,
      meta: {
        ...meta,
        cache: true,
        title: '素材资料库',
        head: true,
        funcID: 'T000202',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/digitalExhibitionHall/designElementsInfo')
    },
    {
      path: 'designElementsInfo/detail/:deCode',
      name: `${pre}designElementsInfo-detail`,
      meta: {
        ...meta,
        cache: true,
        dynamicTitle: true,
        title: '素材资料库详情',
        funcID: 'T000202',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/digitalExhibitionHall/designElementsInfo/detail')
    },
    {
      path: 'researchInfo',
      name: `${pre}researchInfo`,
      meta: {
        ...meta,
        cache: true,
        title: '市场情报库',
        head: true,
        funcID: 'T000203',
        PID: 'T00'
      },
      component: () => import('@/views/digital/digitalExhibitionHall/researchInfo')
    },
    {
      path: 'researchInfo/detail/:resCode/:title',
      name: `${pre}researchInfo-detail`,
      meta: {
        ...meta,
        cache: true,
        dynamicTitle: true,
        title: '市场情报库详情',
        funcID: 'T000203',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/digitalExhibitionHall/researchInfo/components/detail')
    },
    {
      path: 'scmInfo',
      name: `${pre}scmInfo`,
      meta: {
        ...meta,
        cache: true,
        title: '供应链资料',
        head: true,
        funcID: 'T000204',
        PID: 'T00'
      },
      component: () => import('@/views/digital/digitalExhibitionHall/scmInfo')
    },
    {
      path: 'scmInfo/detail/:scmCode/:title',
      name: `${pre}scmInfo-detail`,
      meta: {
        ...meta,
        cache: true,
        dynamicTitle: true,
        title: '供应链资料库详情',
        funcID: 'T000204',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/digitalExhibitionHall/scmInfo/components/detail')
    },
    {
      path: 'resFabric',
      name: `${pre}resFabric`,
      meta: {
        ...meta,
        cache: true,
        title: '面料情报库',
        head: true,
        funcID: 'T000205',
        PID: 'T00'
      },
      component: () => import('@/views/digital/digitalExhibitionHall/resFabric')
    },
  ])('digitalExhibitionHall-')
}
